import { Tabs } from 'antd';
// import Feedbacks from 'pages/Feedbacks';
import { log, getAccess } from 'utils';
import React, { useEffect, useState } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { setActiveTab } from 'state/actions/screens';
import { useParams } from 'react-router-dom/cjs/react-router-dom';
import { fetchConfigs } from 'state/actions/configuration';
import { InfoIcon, TickIcon } from 'assets/icon';
import './Configuration.css';
import ColorForm from 'components/ColorForm';
import MediaConfigurationForm from 'components/MediaConfigurationForm';
// menu icon
import PostIcon from '../../assets/icon/menuConfiguration/post.png';
import PageIcon from '../../assets/icon/menuConfiguration/pages.png';
import TemplateIcon from '../../assets/icon/menuConfiguration/template.png';
import MenuIcon from '../../assets/icon/menuConfiguration/menu.png';
import PostingPage from 'pages/PostingPage';
import AddPostingPage from 'pages/AddPostingPage';
import WebPagesPage from 'pages/WebPagesPage';
import AddWebPagesForm from 'pages/WebPagesPage/AddWebPagesForm';
import WebMenusPage from 'pages/WebMenusPage';
import AddWebMenusForm from 'pages/WebMenusPage/AddWebMenusForm';
import WebLayoutConfigPage from 'pages/WebLayoutConfig';
import { fetchWebContents } from 'state/actions/webContents';
import { fetchWebPages } from 'state/actions/webPages';
import { fetchWebLayout } from 'state/actions/webLayout';
import { fetchWebMenus } from 'state/actions/webMenus';

const { TabPane } = Tabs;

function Configuration() {
  const dispatch = useDispatch();
  const { loading, configData, userData } = useSelector(
    (state) => ({
      loading: state.config.loading,
      configData: state.configuration.config,
      userData: state.auth.userData,
    }),
    shallowEqual
  );

  const { tab: activeTab } = useSelector((state) => ({
    tab: state.screens.tab,
    activeScreen: state.screens.activeScreen,
  }));

  const { siteId } = useParams();
  const [configPages, setConfigPages] = useState();

  useEffect(() => {
    dispatch(fetchConfigs({ siteId }));
  }, [siteId, dispatch]); //eslint-disable-line

  const canRead = (module) => {
    if (userData?.role === 'superadmin') return true;
    const acc = userData?.roleAccess?.access
      ? getAccess(userData, module, siteId)
      : null;
    return !!(acc && acc.read);
  };

  useEffect(() => {
    const newConf = [
      {
        key: 'post',
        title: 'Post',
        active: canRead('post'),
        completeParams: ['Post'],
        image: PostIcon,
        children: <PostingPage loading={loading} userData={userData} />,
      },

      {
        key: 'pages',
        title: 'Pages',
        active: canRead('pages'),
        completeParams: ['pages'],
        image: PageIcon,
        children: <WebPagesPage error={'error'} />,
      },
      // {
      //   key: 'template',
      //   title: 'Template',
      //   active: true,
      //   completeParams: ['template'],
      //   image: TemplateIcon,
      //   children: (
      //     <MediaConfigurationForm
      //       loading={loading}
      //       userData={userData}
      //       configuration={configuration}
      //     />
      //   ),
      // },
      {
        key: 'layout-config',
        title: 'Layout Config',
        active: canRead('layoutConfig'),
        completeParams: ['layout-config'],
        image: MenuIcon,
        children: <WebLayoutConfigPage loading={loading} userData={userData} />,
      },
      {
        key: 'menu',
        title: 'Menu',
        active: canRead('menu'),
        completeParams: ['menu'],
        image: MenuIcon,
        children: (
          // <AddWebMenusForm error={'error'} />
          <WebMenusPage loading={loading} userData={userData} />
        ),
      },
    ];
    setConfigPages(newConf);
  }, [configData, userData, siteId]); //eslint-disable-line

  const handleChangeTab = (activeKey) => {
    log(activeKey);
    dispatch(setActiveTab({ tab: activeKey }));
    switch (activeKey) {
      case 'post':
        dispatch(fetchWebContents({ siteId }));
      case 'pages':
        dispatch(fetchWebPages({ siteId }));
      case 'layout-config':
        dispatch(fetchWebLayout({ siteId }));
      case 'menu':
        dispatch(fetchWebMenus({ siteId }));
    }
  };

  const { TabPane } = Tabs;

  return (
    <div className="configuration">
      <Tabs
        activeKey={activeTab}
        onTabClick={handleChangeTab}
        className="config-tab"
        tabPosition="left"
      >
        {configPages &&
          configPages.map(
            (page) =>
              page.active && (
                <TabPane
                  tab={
                    <div
                      onClick={(e) => e.preventDefault()}
                      className="configuration-nav"
                    >
                      <img src={page.image} className="menuIcon" />
                      <span>{page.title}</span>
                    </div>
                  }
                  style={{
                    paddingLeft: '0px',
                  }}
                  key={page.key}
                >
                  {page.children}
                </TabPane>
              )
          )}
      </Tabs>
    </div>
  );
}

export default Configuration;
